import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 19V5m0 0-6 6m6-6 6 6" }));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
